<div [ngClass]="{ 'hide-toolbar': disableRichText, 'error-outline': hasError }">
  <quill-editor id="quill-editor" [modules]="modules" [formControlName]="customFormControlName"></quill-editor>
  <div *ngIf="enableCounter" class="w-100 align-end" style="display: flex;">
    <div id="counter"></div>
  </div>
</div>
